import { useState } from "react";
import { useGetList, useTranslate } from "ra-core";
import type { Identifier } from "ra-core";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";

import type { BCInteractionLog } from "../types";
import { BCInteractionEntry } from "./BCInteractionEntry";
import { BCInteractionEntryMobile } from "./BCInteractionEntryMobile";

export const BCInteractionsSection = ({
  companyId,
  mobile = false,
}: {
  companyId: Identifier;
  mobile?: boolean;
}) => {
  const translate = useTranslate();
  const [open, setOpen] = useState(false);
  const { data: interactions = [], isPending } = useGetList<BCInteractionLog>(
    "bc_interaction_log",
    {
      filter: { company_id: companyId },
      sort: { field: "interaction_date", order: "DESC" },
      pagination: { page: 1, perPage: 100 },
    },
  );

  if (isPending || interactions.length === 0) return null;

  return (
    <div className="mt-4">
      <Separator className="mb-3" />
      <Button
        variant="ghost"
        className="w-full flex items-center justify-between px-0 h-auto py-1 text-sm font-medium hover:bg-transparent"
        onClick={() => setOpen((v) => !v)}
      >
        <span>
          {translate("resources.bc_interaction_log.section_title", {
            _: "BC Interactions",
          })}{" "}
          <span className="text-muted-foreground">({interactions.length})</span>
        </span>
        {open ? (
          <ChevronUp className="h-4 w-4 text-muted-foreground" />
        ) : (
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        )}
      </Button>
      {open && (
        <div className={mobile ? "divide-y mt-2" : "mt-4 space-y-4"}>
          {interactions.map((interaction, index) =>
            mobile ? (
              <BCInteractionEntryMobile
                key={interaction.id}
                interaction={interaction}
              />
            ) : (
              <div key={interaction.id}>
                <BCInteractionEntry interaction={interaction} />
                {index < interactions.length - 1 && <Separator />}
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};
